module.exports = __webpack_public_path__ + "img/20200514_144338.4c0b0e6e.jpg";